import { render, staticRenderFns } from "./Cupones-cartera.vue?vue&type=template&id=a076c81e"
import script from "./Cupones-cartera.vue?vue&type=script&lang=js"
export * from "./Cupones-cartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports